import type { MouseEvent } from "react";

/*
 * Lets other parts of the chat (e.g. "Mention" in a user's context menu) put
 * text into the composer that's on screen, at the caret.
 */

const EVENT = "atrium:composer-insert";
let listeners = 0;

export function insertIntoComposer(text: string) {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: text }));
}

export function onComposerInsert(fn: (text: string) => void) {
  const h = (e: Event) => fn((e as CustomEvent<string>).detail);
  window.addEventListener(EVENT, h);
  listeners++;
  return () => {
    window.removeEventListener(EVENT, h);
    listeners--;
  };
}

/**
 * Shift+click on a user's name or avatar mentions them in the composer instead
 * of following the link or opening their card. Without a composer on screen
 * the click behaves as usual. Spread onto the clickable element.
 */
export function shiftClickMention(username: string) {
  const active = (e: MouseEvent) => e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey && listeners > 0;
  return {
    // Shift+mousedown would otherwise extend the text selection.
    onMouseDown: (e: MouseEvent) => {
      if (active(e)) e.preventDefault();
    },
    onClick: (e: MouseEvent) => {
      if (!active(e)) return;
      e.preventDefault();
      e.stopPropagation();
      insertIntoComposer(`@${username} `);
    },
  };
}
